/**
 * fetchWithRetry.js — Transient-error retry for deploy-cutover windows.
 *
 * Retries on: network failures (TypeError/NetworkError), 502, 503, 504.
 * These are the exact errors nginx returns during rolling-deploy windows
 * when the new pod hasn't bound its socket yet (manifests as 111 upstream
 * refused → nginx returns 502/503).
 *
 * Exponential backoff: 400ms → 900ms → 2000ms (3 attempts total).
 */
const TRANSIENT_STATUSES = new Set([502, 503, 504]);

export async function fetchWithRetry(url, options = {}, { attempts = 3, baseDelay = 400 } = {}) {
  let lastErr;
  for (let i = 0; i < attempts; i++) {
    try {
      const res = await fetch(url, options);
      if (res.ok || !TRANSIENT_STATUSES.has(res.status)) return res;
      lastErr = new Error(`HTTP ${res.status}`);
    } catch (e) {
      if (e.name === 'AbortError') throw e;
      lastErr = e;
    }
    if (i < attempts - 1) {
      const wait = baseDelay * Math.pow(2.25, i); // 400, 900, 2025
      await new Promise(r => setTimeout(r, wait));
    }
  }
  throw lastErr;
}
